import domP from "dompurify";

const hvitelistedeDomener = [
  "vegvesen.no",
  "skatteetaten.no",
  "lovdata.no",
  "altinn.no",
  "eboks.no", // denne urlen redirekter til https://private.e-boks.com/
  "e-boks.no",
  "private.e-boks.com",
  "digipost.no",
  "politiet.no",
  "autopass.no",
  "kontaktregisteret.no",
  "tffauto.no",
  "difi.no",
  "questback.com",
  "entur.org",
  "nobil.no",
  "trafikverket.se",
  "fintraffic.fi",
  "brreg.no",
  "autopassferje.no",
  "articulate.com",
  "wltpfacts.eu",
  "vitnemalsportalen.no",
  "digdir.no",
  "tff.no",
  "teams.microsoft.com",
];

const rensConfig = {
  ALLOWED_TAGS: [
    // tekst format elementer
    "b",
    "i",
    "em",
    "strong",
    "u",
    "s",
    "mark",
    "small",
    "sub",
    "sup",
    "span",

    // liste elementer
    "ol",
    "ul",
    "li",

    // layout elementer
    "p",
    "br",
    "hr",
    "blockquote",
    "div",

    // overskrifter
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",

    // link
    "a",
  ],
  ALLOWED_ATTR: [
    "class",
    "id",
    "href",
    "target",
    "rel",
    "aria-label",
    "aria-hidden",
    "aria-current",
    "aria-labelledby",
    "aria-describedby",
  ],
};

export function rensHTML(tekst: string) {
  return domP.sanitize(rensUrl(tekst), rensConfig);
}

export function sjekkDomene(href: string): boolean {
  if (
    href.startsWith("#") || // HashRouter link
    href.startsWith("/") || // relative path
    href.startsWith("mailto:") // email link
  ) {
    return true;
  }
  return hvitelistedeDomener.some(domene => {
    /**
     * regex forklart:
     * ma starte med https://
     * kan ha hva som helst som subdomain (https://hva-som_helst.lovdata.no)
     * subdomain ma ende i punktum (https://scamvegvesen.no er ikke lov)
     * subdomain er optional (https://vegvesen.no er lov)
     * "i" gjor den case insensitive (https://VegVesEn.NO er lov)
     * ps: vanlig regex escaper med enkel \ men med template string trenger man \\
     * */

    const regex = new RegExp(`^https:\\/\\/(.*\\.)?${domene}(?!\\.)`, "i");
    return regex.test(href);
  });
}

domP.addHook("afterSanitizeAttributes", function(node) {
  if (node.tagName === "A") {
    const href = node.getAttribute("href");

    if (!href) return; // skjer hvis <a> tag ikke har href

    // sjekk om href tilhorer lista med tillatte domener
    const erTillatDomene = sjekkDomene(href);
    if (!erTillatDomene) {
      // fjern href hvis den ikke er tillatt
      // i praksis blir det da en link i frontend som man kan klikke på men som ikke gjor noe
      node.removeAttribute("href");
      advarTestmiljo(href);
    }
  }
});

function advarTestmiljo(url: string) {
  if (process.env.NODE_ENV !== "production") {
    // advarer utviklere i stm og testmiljo hvorfor linken deres ikke fungerer
    console.warn(
      `href: ${url} ble fjernet fordi den ikke er hvitelistet i tekstapp, sjekk at url'en er stavet riktig og at du bruker https`,
    );
  }
}

function erUrl(str: string): boolean {
  const regex = new RegExp(/^(?:[a-z+]+:)?\/\//i);
  try {
    /**
     * hvis vi ikke kan lage et URL objekt er det ikke en URL og da blir en error thrown
     * regex som sjekker at det er en protokol som slutter med "//" i starten av url
     * slik at ikke "eksempel:" blir tolket som url.
     * */
    return !!(regex.test(str) && new URL(str));
  } catch (_) {
    return false;
  }
}

// hvis alt teksten inneholder er en href som skal mates inn i en <a> i frontend ma denne ogsa vaere i hvitelisten
export function rensUrl(tekst: string) {
  if (erUrl(tekst)) {
    if (sjekkDomene(tekst)) {
      // det er en lovlig url
      return tekst;
    } else {
      advarTestmiljo(tekst);
      // i praksis blir det da en link i frontend som man kan klikke på men som ikke gjor noe
      return "";
    }
  } else {
    // ikke en url
    return tekst;
  }
}
